import React from "react";
import { JhButton } from "designPackages/buttonPackage";
import { JhText } from "designPackages/textPackage";
import Image from "next/image";

interface SalesContactCardProps {
  onContactSalesClick?: () => void;
}

const SalesContactCard: React.FC<SalesContactCardProps> = ({
  onContactSalesClick
}) => {
  const handleContactSales = () => {
    if (onContactSalesClick) {
      onContactSalesClick();
      return;
    }

    // Default behavior: Scroll to ContactSales component or trigger it
    const contactSalesSection = document.querySelector(
      "[data-contact-sales-section]"
    );
    if (contactSalesSection) {
      contactSalesSection.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      // Trigger click on the contact sales button if it exists
      setTimeout(() => {
        const contactSalesButton = contactSalesSection.querySelector("button");
        if (contactSalesButton) {
          (contactSalesButton as HTMLElement).click();
        }
      }, 500);
    }
  };

  return (
    <div className="flex col-span-1 flex-col justify-between gap-4 py-8 px-4 w-full bg-card border border-border rounded-lg">
      <div className="flex flex-col gap-1.5">
        <JhText variant="title6" color="foreground">
          Contact Sales
        </JhText>
        <JhText variant="body2" color="muted-foreground">
          Suitable for Custom quote
        </JhText>
      </div>

      <div className="flex flex-row items-center justify-center gap-1 py-3 w-full border-t border-b border-border">
        <div className="flex flex-row items-center p-0.5 gap-1 h-9">
          <Image
            src="/hire/badge-percent.svg"
            alt="contact-sales"
            width={16}
            height={16}
          />
          <JhText variant="caption1" color="success-foreground">
            Get Exciting Offers
          </JhText>
        </div>
      </div>
      <div className="flex flex-col gap-2.5 w-full">
        <JhText variant="subtitle4" color="foreground">
          What you can do
        </JhText>
        <JhText variant="caption2" color="muted-foreground">
          Select the number of premium jobs you want and receive tailored
          matches from database
        </JhText>
      </div>
      <div className="flex flex-row justify-center items-center gap-1 py-3 w-full">
        <JhButton
          variant="outline"
          size="default"
          className="w-full"
          onClick={handleContactSales}
        >
          Talk to sales
        </JhButton>
      </div>
    </div>
  );
};

export default SalesContactCard;
